import { render, staticRenderFns } from "./CurtainConfigurator.vue?vue&type=template&id=dfa051d6&scoped=true"
import script from "./CurtainConfigurator.vue?vue&type=script&lang=js"
export * from "./CurtainConfigurator.vue?vue&type=script&lang=js"
import style0 from "./CurtainConfigurator.vue?vue&type=style&index=0&id=dfa051d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa051d6",
  null
  
)

export default component.exports